// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { LiveStreamCard } from '@Organisms/LiveStreamData/LiveStreamCard';
import { StateProvider } from '@Context/StateProvider';
import { AuditOutput } from 'thehive-sdk';
import { STREAM_EVENTS } from '@Services/StreamSrv';

import './LiveStreamData.scss';

interface LiveStreamDataProps {
    liveFeed: AuditOutput[];
}

export const deduplicateAudit = (audits: AuditOutput[]): AuditOutput[] => {
    const listRequestId = audits.map((audit) => audit.base.requestId);
    return audits.filter((audit, index) => {
        const keep = !(
            listRequestId.indexOf(audit.base.requestId) < index &&
            [STREAM_EVENTS.ACTION, STREAM_EVENTS.ANALYZER].includes(audit.base.objectType.toLocaleLowerCase())
        );
        return keep;
    });
};

export const LiveStreamData = ({ liveFeed }: LiveStreamDataProps): ReactElement => {
    const targetWindow = window.opener ? window.opener : '';

    return (
        <div className="live-stream-data">
            <StateProvider initialState={{ targetWindow }}>
                <>
                    {liveFeed?.map((audit) => (
                        <LiveStreamCard key={audit.base._id} audit={audit} />
                    ))}
                </>
            </StateProvider>
        </div>
    );
};
